import React from 'react';
import { ExcelUploadModal as SharedExcelUploadModal } from '../../../settlement/components/ExcelUploadModal';
import { parseSettlementIdExcel } from '../../utils/parseSettlementIdExcel';
import { downloadSettlementIdTemplate } from '../../utils/generateSettlementIdTemplate';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  /**
   * 파싱된 ID 목록을 상위로 전달. 상위는 그대로 Preview API 호출로 이어가
   * 다른 관리자 페이지의 엑셀 업로드 플로우와 일관성을 유지한다.
   */
  onSubmit: (ids: number[]) => void;
};

/**
 * 정산 기준일 변경 대상 ID 리스트를 엑셀/CSV 로 업로드하기 위한 모달.
 *
 * 본 컴포넌트는 `views/settlement/components/ExcelUploadModal` 의 도메인 wrapper —
 * parser / template / 로그 prefix 만 도메인에 맞게 주입하고 UI/state 는 공유 모달이
 * 담당. 완료일 변경 도메인과 동일한 사용 패턴.
 */
export const ExcelUploadModal = ({
  isOpen,
  onCancel,
  onSubmit,
}: Props): React.JSX.Element => (
  <SharedExcelUploadModal
    isOpen={isOpen}
    onCancel={onCancel}
    onSubmit={onSubmit}
    parseFile={parseSettlementIdExcel}
    onDownloadTemplate={downloadSettlementIdTemplate}
    logPrefix="[SettlementDateAdjustment]"
  />
);
